import { render, staticRenderFns } from "./BaseOutlineInfoButton.vue?vue&type=template&id=2f580da6&scoped=true&"
import script from "./BaseOutlineInfoButton.vue?vue&type=script&lang=js&"
export * from "./BaseOutlineInfoButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseOutlineInfoButton.vue?vue&type=style&index=0&id=2f580da6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f580da6",
  null
  
)

export default component.exports